/* tslint:disable */
/* eslint-disable */
/* @relayHash 5a6b3c55000091e299bce8aacccf719e */

import { ConcreteRequest } from "relay-runtime";
export type AcceptFileToVerifyInput = {
    automatedVerificationID: string;
    filename: string;
    token: string;
    filestage: string;
};
export type UploadFiles_AcceptMutationVariables = {
    input: AcceptFileToVerifyInput;
};
export type UploadFiles_AcceptMutationResponse = {
    readonly acceptFileToVerify: string;
};
export type UploadFiles_AcceptMutation = {
    readonly response: UploadFiles_AcceptMutationResponse;
    readonly variables: UploadFiles_AcceptMutationVariables;
};



/*
mutation UploadFiles_AcceptMutation(
  $input: AcceptFileToVerifyInput!
) {
  acceptFileToVerify(input: $input)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "AcceptFileToVerifyInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "acceptFileToVerify",
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "UploadFiles_AcceptMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "UploadFiles_AcceptMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "UploadFiles_AcceptMutation",
            "id": null,
            "text": "mutation UploadFiles_AcceptMutation(\n  $input: AcceptFileToVerifyInput!\n) {\n  acceptFileToVerify(input: $input)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '1011fd4ac9dc07840830400eca627167';
export default node;
